import { css } from 'styled-components'

// Width override for flyouts that differ from BaseFlyout's default 580 px
// (spacing(145)). The class is placed on the portal container (via BaseFlyout
// className → portalClassName), so .BaseFlyout-Container inside is reachable.
//
// Only initial/close right values are overridden here; the open state (right: 0)
// is inherited from BaseFlyout, keeping consumer overrides cascade-friendly.
export const flyoutWidthOverride = (widthPx: number) => css`
  .BaseFlyout-Container {
    /* Clamp to the viewport so the flyout stays 100vw on small screens,
       matching the legacy RightFlyout which went full-width at narrow
       breakpoints rather than overflowing at a fixed pixel width. */
    right: calc(-1 * min(${widthPx}px, 100vw));

    &.ReactModal__Content--before-close {
      right: calc(-1 * min(${widthPx}px, 100vw));
    }

    .BaseFlyout-Content {
      width: min(${widthPx}px, 100vw);
    }
  }
`

// Legacy RightFlyout rendered its content edge-to-edge (no padding, full height)
// and provided no close button of its own — content components (e.g.
// ActionRightFlyoutContent) supply their own header + close button + padding.
// BaseFlyout, by contrast, wraps children in a padded .BaseFlyout-Body. This
// override strips that padding so migrated consumers keep their original layout.
// Pair it with `showCloseButton={false}` to drop BaseFlyout's own close button.
// Selectors are nested to match the specificity of BaseFlyout's own rules
// (which live under .BaseFlyout-Container .BaseFlyout-Content); RightFlyout's
// styles are injected after BaseFlyout's, so equal specificity resolves in our
// favour by source order — same approach as flyoutWidthOverride above.
export const flyoutChromelessBodyStyle = css`
  .BaseFlyout-Container {
    .BaseFlyout-Content {
      /* BaseFlyout applies side gutters to direct children; strip them so
         content is edge-to-edge. */
      & > * {
        padding-left: 0;
        padding-right: 0;
      }

      .BaseFlyout-Body {
        padding-top: 0;
        padding-bottom: 0;
      }
    }
  }
`
